module.exports = __webpack_public_path__ + "assets/7fc34d686c07af8cfd1b6a1f9fed4818.mp3";